Namespace.create('cv.Views.Team.Setup').ShareView = Marionette.LayoutView.extend({
  className : 'view-team-setup-share',

  template: cv.Templates['team/setup/share/view'],

  events : {
    'click .form-save' : 'toDashboard'
  },

  validation: {
  },

  templateHelpers: function(){
    return {
      url : this.model.get('url')
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this.model, 'sync', function(){
      this.$('.form-save').removeClass('button-disabled');
    }, this);

    console.log('ShareView initialized.');
  },

  toDashboard: function(e){
    e.preventDefault();

    top.location = '/team/' + this.model.get('stub') + '/admin/dashboard';
  },

  onAttach: function(){
    this.model.fetch({
      reset: true,
      success: _.bind(function(){
        this.render();
      }, this)
    })

    // Change document title
    document.title = 'Team Setup | Spread the Word';
  }
});
